import FindInPageRoundedIcon from '@mui/icons-material/FindInPageRounded'
import { Stack } from '@mui/material'
import Label from 'components/Label'
import React from 'react'

export const EmptyList: React.FC = () => {
  return (
    <Stack direction='column' alignItems='center' justifyContent='center' spacing={1}>
      <FindInPageRoundedIcon sx={{ height: 72, width: 72, color: 'text.disabled' }} />
      <Label text='Não há registros disponíveis' bold />
    </Stack>
  )
}
